import React, { useEffect, useRef, useState } from 'react'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Pagination from '../Layout/Pagination'
import { formatDate, formatDateNumber, thousandSeparator } from '../../utils/helpers'

const TotalAgentTable = ({
  filterData,
  entities,
}) => {
  const inputRef = useRef(null)
  const divRef = useRef(null)
  const [showSearchBox, setShowSearchBox] = useState(false)
  const [filteredData, setFilteredData] = useState(entities)


  const [totalPeople, setTotalPeople ] = useState(null)
  const [totalAllPeople, setTotalAllPeople ] = useState(null)

  const [currentPage, setCurrentPage] = useState(1);

  const handleShowSearchBox = () => {
    setShowSearchBox(!showSearchBox)
    if (setShowSearchBox) inputRef.current.focus()
  }

  const handleSearchData = (e) => {
    let searchQuery = e.target.value;
  
    const filteredData = entities.filter((row) => {
      return Object.values(row).some((value) => {
        if (typeof value === 'string' || typeof value === 'number') {
          if (typeof value === 'string' && value.toLowerCase().includes(searchQuery.toLowerCase())) {
            return true;
          }
          if (typeof value === 'number' && value.toString().includes(searchQuery)) {
            return true;
          }
        }
        return false;
      });
    });
  
    setCurrentPage(1)
    setFilteredData(filteredData);
    divRef.current.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  };


  useEffect(() => {
    if (entities) {
      const totalPeople = entities.reduce((acc, item) => acc + item.TotalPeople, 0)
      const totalAllPeople = entities.reduce((acc, item) => acc + item.TotalAllPeople, 0)

      setTotalPeople(totalPeople)
      setTotalAllPeople(totalAllPeople)
    }
  }, [entities])


  return (
    <>
      <div className='table-wrapper'>
        <div className='table-header'>
          <p className='title'>{ filterData.DateYear } No of New Hire in { filterData.LiveListBy }</p>
          <div className='search-wrapper'>
            <div className='btn-search'>
              <FontAwesomeIcon
                onClick={ handleShowSearchBox }
                icon={ faMagnifyingGlass }
                className={ 'icon ' + (showSearchBox ? 'text-primary' : '') }
              />
              <input
                ref={ inputRef }
                type='text'
                onInput={ handleSearchData }
                onBlur={ () => setShowSearchBox(false) }
                placeholder='Search for any keywords'
                className={ (showSearchBox ? 'searchbox-open' : 'w-0') }
              />
            </div>
          </div>
        </div>

        <div className='border-border border rounded-[10px] shadow-md overflow-hidden flex-1 relative'>
          <div ref={ divRef } className='w-full h-full overflow-scroll hide-scrollbar bg-gray-200'>
            <div className='md:w-full w-[1080px] max-h-[184px]'>
              <table className='w-full border-collapse bg-white'>
                <thead className='border-b border-gray-200 bg-gray-200 text-gray-one sticky top-0'>
                  <tr>
                    <th scope='col' className='text-[11px] font-semibold px-1 py-2 whitespace-nowrap text-center'>
                      #
                    </th>
                    <th scope='col' className='text-[11px] font-semibold p-2 whitespace-nowrap text-center'>
                      Branch Name
                    </th>
                    <th scope='col' className='text-[11px] font-semibold p-2 whitespace-nowrap text-center'>
                      Total of New Hire
                    </th>
                    <th scope='col' className='text-[11px] font-semibold p-2 whitespace-nowrap text-center'>
                      Total of People
                    </th>
                  </tr>
                </thead>
                
                <tbody>
                  {filteredData.map((item, idx) => (
                    <tr key={ 'agentsales_' + idx } className='border-gray-200 border-b text-gray-two hover:bg-gray-50'>
                      <td className='text-xs font-normal px-1 py-2 border-r whitespace-nowrap text-center'>{ idx + 1 }</td>
                      <td className='text-xs font-normal p-2 border-r whitespace-nowrap text-center'>{ item?.BranchName }</td>
                      <td className='text-xs font-normal p-2 border-r whitespace-nowrap text-center'>{ item?.TotalPeople?.toLocaleString() ?? 0 }</td>
                      <td className='text-xs font-normal p-2 whitespace-nowrap text-center'>{ item?.TotalAllPeople?.toLocaleString() ?? 0 }</td>
                    </tr>
                  ))}

                  <tr className='border-gray-200 text-gray-one bg-gray-100 sticky bottom-0'>
                    <td colSpan={2} className='p-2 border-r whitespace-nowrap text-xs font-semibold text-end'>Total:</td>
                    <td className='text-xs font-semibold p-2 border-r whitespace-nowrap text-center'>{ totalPeople?.toLocaleString() ?? 0 }</td>
                    <td className='text-xs font-semibold p-2 whitespace-nowrap text-center'>{ totalAllPeople?.toLocaleString() ?? 0 }</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TotalAgentTable